module.exports = __webpack_public_path__ + "img/shirt-1.e18fc42b.jpg";